<div class='rn-toggle-switch' [matTooltip]="tooltipText || ''">
  <input type="checkbox" [id]="inputName" [attr.name]="inputName" [checked]="toggleModel" [disabled]="disabled" (change)="handleChange($event)"/>
  <label [for]="inputName" [class.disabled]="disabled">{{labelText}}</label>
</div>
